/**
 * Vagdevi's portrait, wherever the assistant is named.
 *
 * One component rather than an `<img>` at each call site: the mark appears on
 * the launcher, in the panel header and on the player's third tab, and when
 * those were three copies of the same six attributes the tab was missed and
 * one screen showed a portrait beside a glyph for the same assistant.
 *
 * The artwork is cropped to the face so it fills its own frame. The whole
 * seated figure was tried and brought the painting's pale background with it,
 * which at this size is a light margin inside the circle and reads as a
 * sticker rather than as the product's own mark.
 */

interface Props {
  /** Rendered size in CSS pixels. The asset is 144px, so 48 is a sensible top. */
  size?: number;
  className?: string;
}

export function VagdeviMark({ size = 20, className }: Props) {
  return (
    <img
      // Decorative everywhere it is used: the name is written beside it in
      // every case, so announcing the picture as well would say it twice.
      alt=""
      aria-hidden="true"
      src="/brand/vagdevi.webp"
      className={className ? `vagdevi-mark ${className}` : 'vagdevi-mark'}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      loading="lazy"
      decoding="async"
    />
  );
}
